<template>
  <main>
    <section class="catalog-opened">
      <div class="container">
        <h2 class="title catalog-opened__title">
          {{ $t('pages.catalog.title') }}
        </h2>
        <!-- <nav class="catalog-opened__nav">
          <ul class="catalog-opened__nav-list">
            <li class="catalog-opened__nav-item"
                v-for="category in categories"
                :key="category.id">
              <h3 class="catalog-opened__sub-title">
                <NuxtLink :to="`/catalog/${category.slug}`"
                          class="catalog-opened__nav-link"
                          :class="{
                            'catalog-opened__nav-link--open': $route.path === `/catalog/${category.slug}`
                          }">
                  {{ category.title }}
                </NuxtLink>
              </h3>
            </li>
          </ul>
        </nav> -->
        <TheCatalog v-if="theCatalogProps.categories.length"
                    v-bind="theCatalogProps" />

        <NuxtPage />
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import {
  TheCatalog,
  ITheCatalogProps,
} from '@/components';

const categoriesStore = useCategoriesStore();

onMounted(() => {
  categoriesStore.getAll();
});

// const categories = categoriesStore.data;

const theCatalogProps = computed<ITheCatalogProps>(() => {
  return {
    categories: categoriesStore.data,
    hideTitle: true,
    hideButton: true,
  };
});
</script>

<style lang="scss" scoped>
.catalog-opened {
  margin-top: -2px;
  margin-bottom: 60px;
  z-index: 2;
}

.catalog-opened__title {
  text-align: center;
  margin-bottom: 39px;
}

.catalog-opened__nav {
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
}

.catalog-opened__nav-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1002px;
  width: 100%;
}

.catalog-opened__nav-item {
  padding-left: 8px;
  padding-right: 8px;
}

.catalog-opened__sub-title {
  text-align: center;
}

.catalog-opened__nav-link {
  font-family: 'Cormorant', serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 151%;
  color: var(--color-black-main);
  text-transform: uppercase;
  transition: color 0.3s linear;
}

.catalog-opened__nav-link:hover,
.catalog-opened__nav-link:focus-visible {
  color: var(--color-brown);
}

.catalog-opened__nav-link--open {
  color: var(--color-brown);
}

@media (max-width: 992px) {
  .catalog-opened__nav-list {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .catalog-opened {
    background-image: url('/img/catalog-open-bg.png');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    padding-top: 136px;
    margin-top: -167px;
    margin-bottom: 20px;
  }

  .catalog-opened__title {
    margin-bottom: 26px;
  }

  .catalog-opened__nav {
    margin-bottom: 30px;
  }

  .catalog-opened__nav-item:not(:last-child) {
    margin-bottom: 20px;
  }

  .catalog-opened__nav-link {
    font-size: 12px;
    font-weight: 700;
  }
}
</style>
